<template>
  <div>
    <section role="modal">
      <div
        class="modal fade"
        id="finalizaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="finalizaModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="finalizaModalLabel">
                Finalizar Avaliação
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Você concorda com o resultado da sua avaliação?
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                tipo="button"
                estilo="cheio-cinza"
                rotulo="Cancelar"
                icone="cancela-modal"
                dismiss="modal"
              >
              </botao>
              <botao
                tipo="button"
                estilo="vazado-verde"
                rotulo="Não"
                icone="fa-times fa-lg"
                @clicado="discorda()"
              >
              </botao>
              <botao
                tipo="button"
                estilo="cheio-verde"
                rotulo="Sim"
                icone="ok-modal"
                @clicado="concorda()"
              >
              </botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>Funcionário&nbsp;<small>(Avaliado)</small></h4>
                <div class="row">
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <label>Nome:</label>
                    <p>{{ avaliacao.avaliado.pessoa.nome }}</p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>Registro:</label>
                    <p>{{ avaliacao.avaliado.registroFormatado }}</p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>Cargo:</label>
                    <p>{{ avaliacao.avaliado.cargoPrincipal }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>Chefe Imediato&nbsp;<small>(Avaliador)</small></h4>
                <div class="row">
                  <div class="form-group col-lg-5 col-md-5 col-sm-5">
                    <label>Nome:</label>
                    <p>
                      {{ avaliacao.avaliador && avaliacao.avaliador.pessoa && avaliacao.avaliador.pessoa.nome ? avaliacao.avaliador.pessoa.nome : 'Nome não disponível' }}
                    </p>
                  </div>
                  <div class="form-group col-lg-3 col-md-3 col-sm-3">
                    <label>Registro:</label>
                    <p>
                      {{ avaliacao.avaliador ? avaliacao.avaliador.registroFormatado : 'Sem registro' }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Avaliação de Ficha Funcional&nbsp;<small
                    >(Preenchido pelo DEGEPAT)</small
                  >
                </h4>
                <div class="row">
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Número de Faltas:</label>
                    <p>{{ avaliacao.quantidadeFaltas }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesFaltas }}</p>
                  </div>
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Número de Atrasos:</label>
                    <p>{{ avaliacao.quantidadeAtrasos }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesAtrasos }}</p>
                  </div>
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>Repreensões:</label>
                    <p>{{ avaliacao.quantidadeRepreensoes }}</p>
                    <label>Deduções:</label>
                    <p>{{ avaliacao.quantidadeDeducoesRepreensoes }}</p>
                  </div>
                  <div class="form-group col-sm-3 col-xs-6">
                    <label>NOTA FINAL (A):</label>
                    <p>{{ avaliacao.notaFichaFuncional }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <h4>Avaliação de Desempenho</h4>
                <div v-if="ehRecemEstavel">
                  <div class="row">
                    <div class="col-lg-12">
                      <p style="text-align: justify">
                        O estatutário que
                        <strong
                          >se tornou estável no segundo semestre de
                          {{ avaliacao.competencia.ano }}</strong
                        >
                        terá sua nota de desempenho atribuída automaticamente no
                        sistema, considerando a 5º avaliação do estágio
                        probatório. <strong>Não será necessário</strong> incluir
                        notas de <strong>autoavaliação</strong>,
                        <strong>nem ser avaliado</strong> pelo chefe imediato. A
                        ficha de avaliação de
                        {{ avaliacao.competencia.ano }} estará disponível
                        <strong>somente para visualização</strong>.
                      </p>
                      <div class="row">
                        <div class="form-group col-sm-4">
                          <label>AVALIAÇÃO FICHA FUNCIONAL:</label>
                          <p>{{ avaliacao.notaFichaFuncional }}</p>
                        </div>
                        <div class="form-group col-sm-4">
                          <label>AVALIAÇÃO ESTÁGIO PROBATÓRIO:</label>
                          <p>{{ avaliacao.mediaEstagioProbatorio }}</p>
                        </div>
                        <div class="form-group col-sm-4">
                          <label>PONTUAÇÃO FINAL:</label>
                          <p>{{ pontuacaoFinalProbatorio }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <b>Parâmetros&nbsp;</b>
                  <div>
                    <table
                      class="table table-striped table-condensed hidden-xs"
                    >
                      <thead>
                        <tr>
                          <th align="left"><span>Acima do esperado</span></th>
                          <th align="left"><span>Dentro do esperado</span></th>
                          <th align="left">
                            <span>Parcialmente esperado</span>
                          </th>
                          <th align="left"><span>Abaixo do esperado</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-title="Acima do esperado" align="left">
                            (7-8 pontos)
                          </td>
                          <td data-title="Dentro do esperado" align="left">
                            (5-6 pontos)
                          </td>
                          <td data-title="Parcialmente esperado" align="left">
                            (3-4 pontos)
                          </td>
                          <td data-title="Abaixo do esperado" align="left">
                            (1-2 pontos)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table table-striped table-condensed visible-xs"
                    >
                      <tbody>
                        <tr>
                          <td>Acima do esperado</td>
                          <td>(7-8 pontos)</td>
                        </tr>
                        <tr>
                          <td>Dentro do esperado</td>
                          <td>(5-6 pontos)</td>
                        </tr>
                        <tr>
                          <td>Parcialmente esperado</td>
                          <td>(3-4 pontos)</td>
                        </tr>
                        <tr>
                          <td>Abaixo do esperado</td>
                          <td>(1-2 pontos)</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style="padding-top: 10px">
                    <table
                      class="table table-striped table-condensed hidden-xs"
                    >
                      <thead>
                        <tr>
                          <th align="left"></th>
                          <th align="left">
                            <span>Indicadores de Desempenho</span>
                          </th>
                          <th align="center" style="min-width: 135px">
                            <span>Autoavaliação (B)</span>
                          </th>
                          <th align="center" style="min-width: 104px">
                            <span>Avaliador (C)</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(nota, index) in notasOrdenadas"
                          :key="nota.id"
                          :class="{ 'has-error': errors.has('name' + index) }"
                        >
                          <td data-title="" align="left">
                            {{ nota.item.codigo }}
                          </td>
                          <td
                            data-title="Indicadores de Desempenho"
                            align="left"
                          >
                            <b>{{ nota.item.titulo }}&nbsp;</b>
                            <esconde-div>{{ nota.item.descricao }}</esconde-div>
                          </td>
                          <td data-title="Autoavaliação (B)" align="left">
                            <input
                              type="text"
                              size="3"
                              :name="'notaB' + index"
                              :id="'notaB' + index"
                              v-validate="
                                'required|numeric|min_value:1|max_value:8'
                              "
                              data-vv-as="Nota"
                              v-model="nota.notaAutoAvaliacao"
                              :disabled="habilitaCampoAvaliado"
                            />
                            <span
                              v-show="errors.has('notaB' + index)"
                              class="error"
                              >{{ errors.first('notaB' + index) }}</span
                            >
                          </td>
                          <td data-title="Avaliador (C)" align="left">
                            <input
                              type="text"
                              size="3"
                              :name="'notaC' + index"
                              :id="'notaC' + index"
                              v-validate="
                                'required|numeric|min_value:1|max_value:8'
                              "
                              data-vv-as="Nota"
                              v-model="nota.notaAvaliador"
                              :disabled="habilitaNotasAvaliador"
                            />
                            <span
                              v-show="errors.has('notaC' + index)"
                              class="error"
                              >{{ errors.first('notaC' + index) }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td>
                            <b
                              >TOTAL DE PONTOS DA AUTOAVALIAÇÃO (B) E DO
                              AVALIADOR (C):
                            </b>
                          </td>
                          <td style="padding-left: 12px">
                            {{ somaAutoavaliacao }}
                          </td>
                          <td style="padding-left: 12px">
                            {{ somaAvaliador }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                    <table
                      class="table table-striped table-condensed visible-xs"
                    >
                      <thead>
                        <tr>
                          <th align="left"></th>
                          <th align="left">
                            <span>Indicadores de Desempenho</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(nota, index) in notasOrdenadas"
                          :key="nota.id"
                          :class="{ 'has-error': errors.has('name' + index) }"
                        >
                          <td data-title="" align="left">
                            {{ nota.item.codigo }}
                          </td>
                          <td
                            data-title="Indicadores de Desempenho"
                            align="left"
                          >
                            <b>{{ nota.item.titulo }}&nbsp;</b>
                            <esconde-div>{{ nota.item.descricao }}</esconde-div>
                            <div style="display: flex">
                              <div class="item">
                                <p>Autoaval. (B)</p>
                                <input
                                  type="number"
                                  :name="'notaB' + index"
                                  id="notaB"
                                  v-validate="
                                    'required|numeric|min_value:1|max_value:8'
                                  "
                                  data-vv-as="Nota"
                                  v-model="nota.notaAutoAvaliacao"
                                  :disabled="habilitaCampoAvaliado"
                                />
                                <span
                                  v-show="errors.has('notaB' + index)"
                                  class="error"
                                >
                                  {{ errors.first('notaB' + index) }}</span
                                >
                              </div>
                              <div class="item">
                                <p>Avaliador (C)</p>
                                <input
                                  type="number"
                                  :name="'notaC' + index"
                                  id="notaC"
                                  v-validate="
                                    'required|numeric|min_value:1|max_value:8'
                                  "
                                  data-vv-as="Nota"
                                  v-model="nota.notaAvaliador"
                                  :disabled="habilitaNotasAvaliador"
                                />
                                <span
                                  v-show="errors.has('notaC' + index)"
                                  class="error"
                                >
                                  {{ errors.first('notaC' + index) }}</span
                                >
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td>
                            <b>TOTAL DE PONTOS: </b>
                            <div style="display: flex">
                              <div class="item">
                                <p>Autoaval. (B)</p>
                                {{ somaAutoavaliacao }}
                              </div>
                              <div class="item">
                                <p>Avaliador (C)</p>
                                {{ somaAvaliador }}
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-4 col-md-4 col-sm-4">
                      <label>MÉDIA (M) = (B + C) / 2:</label>
                      <p>{{ mediaAvaliacoes }}</p>
                    </div>
                    <div class="form-group col-lg-4 col-md-4 col-sm-4">
                      <label>PONTUAÇÃO FINAL (A + M):</label>
                      <p>{{ pontuacaoFinal }}</p>
                    </div>
                    <div class="form-group col-lg-4 col-md-4 col-sm-4">
                      <label>Data da Avaliação</label>
                      <p>{{ dataAvaliacao }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-default" v-if="!ehRecemEstavel">
              <div class="card-content">
                <h4>Anuência</h4>
                <div class="row">
                  <div class="col-lg-12">
                    <p style="text-align: justify">
                      Na hipótese de o servidor não concordar com a pontuação
                      final, poderá negociar com o Avaliador. Essa negociação
                      das notas deverá ocorrer até o prazo final. Quando as
                      notas forem definidas, o Avaliado deverá clicar no botão
                      "Entregar" e selecionar dentre as opções “Concordo” ou
                      “Discordo” e salvar para encerrar a Avaliação. A partir
                      deste momento as notas não poderão ser alteradas.
                    </p>
                    <p style="text-align: justify">
                      Em caso de discordância, o servidor avaliado deverá abrir 
                      processo digital de Recurso de Notas de Avaliação, em até 10 (dez) 
                      dias úteis contados a partir da data do prazo final da avaliação.
                    </p>
                  </div>
                </div>
                <div
                  class="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8"
                  v-if="avaliacao.aceita == true || avaliacao.aceita == false"
                >
                  <div class="card sub-card sub-card-content">
                    <div class="anuencia">
                      Servidor avaliado
                      <span class="anuencia-resultado">{{
                        avaliacao.aceita ? 'CONCORDA' : 'NÃO CONCORDA'
                      }}</span>
                      com a pontuação final.
                    </div>
                  </div>
                </div>
                <p v-else></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-md-12">
            <botao
              estilo="vazado-verde-esq"
              rotulo="Voltar"
              icone="voltar"
              @clicado="voltar()"
            >
            </botao>
            <botao
              estilo="cheio-verde-dir"
              rotulo="Entregar"
              icone="fa-check fa-lg"
              v-if="mostraFinalizar"
              @clicado="valida('finalizar')"
            >
            </botao>
            <botao
              :estilo="mostraFinalizar ? 'vazado-verde-dir' : 'cheio-verde-dir'"
              rotulo="Salvar"
              icone="fa-floppy-o fa-lg"
              v-if="mostraSalvar"
              @clicado="valida('salvar')"
            >
            </botao>
            <span
              v-tooltip.bottom="
                'Visual. impres. finalizadas com Concordo ou Discordo'
              "
              class="disabled-tooltip"
            >
              <botao
                :estilo="ehAvaliador ? 'vazado-verde-dir' : 'cheio-verde-dir'"
                rotulo="Imprimir"
                icone="imprimir-tabela"
                v-if="mostraImprimir"
                @clicado="imprime(avaliacao.id)"
                :disabled="(avaliacaoFinalizada || ehAvaliador || naoFinalizadoComPeriodoEncerrado) ? false : true"
              >
              </botao>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Avaliacao from '@/domain/avaliacao';
import Avaliado from '@/domain/avaliado';
import Avaliador from '@/domain/avaliador';
import Botao from '@/components/botao';
import EscondeDiv from '@/components/esconde-div';
import AvaliacaoService from '@/services/avaliacaoService';
import PeriodosService from '@/services/periodosService';
import obtemImpressao from '@/services/obtemImpressao';
import DateHelper from '@/helpers/DateHelper';
import PeriodoAtualHelper from '@/helpers/PeriodoAtualHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import { setTimeout } from 'timers';

export default {
  name: 'DetalhaAvaliacao',

  data() {
    return {
      avaliacao: {},
      periodos: {},
      notas: [],
      avaliadorId: this.$route.params.idAvaliador,
      funcionarioId: this.$route.params.idAvaliado,
      mostraParametros: false,
      mostraComprometimento: false,
      mostraDedicacao: false,
      mostraRelacionamento: false,
      mostraAtendimento: false,
      mostraCapacidade: false,
      apiErrors: null,
    };
  },

  computed: {
    cargo() {
      return this.avaliacao.avaliado.cargoReadaptado
        ? this.avaliacao.avaliado.cargoReadaptado
        : this.avaliacao.avaliado.cargoPrincipal;
    },
    cargoChefeImediato() {
      return `${this.avaliacao.avaliador.cargoPrincipal} - ${this.avaliacao.uorAvaliador.sigla}`;
    },
    dataInicioReferencia() {
      return DateHelper.convertDateToPtbr(this.periodos.dataInicioReferencia);
    },
    dataFimReferencia() {
      return DateHelper.convertDateToPtbr(this.periodos.dataFimReferencia);
    },
    notasOrdenadas() {
      return this.avaliacao.notas.sort((a, b) => {
        if (a.item.codigo < b.item.codigo) return -1;
        if (a.item.codigo > b.item.codigo) return 1;
      });
    },
    dataAvaliacao() {
      if (this.avaliacao.dataAvaliacao) {
        return DateHelper.convertDateToPtbr(this.avaliacao.dataAvaliacao);
      }
    },
    somaAutoavaliacao() {
      var soma = 0;
      this.avaliacao.notas.forEach(nota =>
        nota.notaAutoAvaliacao
          ? (soma += parseInt(nota.notaAutoAvaliacao))
          : soma,
      );
      return soma;
    },
    somaAvaliador() {
      var soma = 0;
      this.avaliacao.notas.forEach(nota =>
        nota.notaAvaliador ? (soma += parseInt(nota.notaAvaliador)) : soma,
      );
      return soma;
    },
    mediaAvaliacoes() {
      return (this.somaAutoavaliacao + this.somaAvaliador) / 2;
    },
    pontuacaoFinal() {
      return this.avaliacao.notaFichaFuncional + this.mediaAvaliacoes;
    },
    pontuacaoFinalProbatorio() {
      return (
        this.avaliacao.notaFichaFuncional +
        this.avaliacao.mediaEstagioProbatorio
      );
    },
    ehAvaliador() {
      if (!this.avaliadorId || !this.avaliacao.avaliador) return false;
        return this.avaliadorId == this.avaliacao.avaliador.id;
    },
    periodoValido() {
      return PeriodoAtualHelper.validaPeriodo(
        this.periodos.dataInicioLancamento,
        this.periodos.dataFimLancamento,
      );
    },
    naoFinalizadoComPeriodoEncerrado() {
      return this.avaliacao.aceita == null && PeriodoAtualHelper.periodoEncerrado(this.periodos.dataFimLancamento);
    },
    avaliacaoFinalizada() {
      return this.avaliacao.aceita != null;
    },
    ehRecemEstavel() {
      return this.avaliacao.mediaEstagioProbatorio > 0;
    },
    habilitaCampoAvaliado() {
      let resultado =
        !this.ehAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return !resultado;
    },
    habilitaNotasAvaliador() {
      let resultado =
        this.ehAvaliador && this.periodoValido && !this.avaliacaoFinalizada;
      return !resultado;
    },
    mostraSalvar() {
      let resultado =
        this.periodoValido && !this.avaliacaoFinalizada && !this.ehRecemEstavel;
      return resultado;
    },
    mostraFinalizar() {
      let foiAvaliado = this.somaAvaliador > 0;
      let seAutoAvaliou = this.somaAutoavaliacao > 0;
      let resultado =
        this.periodoValido &&
        !this.ehAvaliador &&
        foiAvaliado &&
        seAutoAvaliou &&
        !this.avaliacaoFinalizada &&
        !this.ehRecemEstavel;
      return resultado;
    },
    mostraImprimir() {
      return (
        !this.periodoValido || this.ehAvaliador || this.avaliacaoFinalizada
      );
    },
  },

  methods: {
    voltar() {
      this.$router.go(-1);
    },
    valida(metodo) {
      this.$validator.validateAll().then(success => {
        if (success) {
          metodo === 'salvar' ? this.salvar() : this.finalizar();
          return;
        }
        this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    salvar() {
      const sentences = [
        {
          id: 1,
          message: 'Deseja salvar essa avaliação?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: async () => {
          await this.gravaFinalizaAvaliacao(
            this.avaliacao.id,
            this.avaliacao,
            null,
          );
          this.$root.$refs.toastr.s('Avaliação salva', 'Sucesso');
          this.chamaProximaTela();
        },
        title: 'Salvar Avaliação',
      });
    },
    async gravaFinalizaAvaliacao(id, item, aceita) {
      item.dataAvaliacao = DateHelper.convertDateToApiDate(new Date());
      item.aceita = aceita;
      try {
        return await AvaliacaoService.atualiza(id, item);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    finalizar() {
      jQuery('#finalizaModal').modal('show');
    },
    async discorda() {
      await this.gravaFinalizaAvaliacao(
        this.avaliacao.id,
        this.avaliacao,
        false,
      );
      this.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
      jQuery('#finalizaModal').modal('hide');
      this.$router.push({ name: 'Avaliacao' });
    },
    async concorda() {
      await this.gravaFinalizaAvaliacao(
        this.avaliacao.id,
        this.avaliacao,
        true,
      );
      this.$root.$refs.toastr.s('Avaliação finalizada', 'Sucesso');
      jQuery('#finalizaModal').modal('hide');
      this.$router.push({ name: 'Avaliacao' });
    },
    async imprime(id) {
      const endpoint = `avaliacoes-periodicas/${id}/ficha`;

      try {
        await obtemImpressao(endpoint);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    obtemAvaliacaoENotas() {
      const avaliacoes = JSON.parse(sessionStorage.getItem('periodos'));
      console.log(avaliacoes)
      this.avaliacao = avaliacoes.find(
        item => item.avaliado.id == this.funcionarioId,
      );
      this.periodos = this.avaliacao.competencia.periodos[0];
    },
    async obtemAvaliados(funcionarioId, idMes) {
      try {
        const avaliacoes = await PeriodosService.lista(funcionarioId, idMes);
        sessionStorage.setItem('periodos', JSON.stringify(avaliacoes));
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async chamaProximaTela() {
      if (this.ehAvaliador) {
        let avaliadorId = this.avaliacao.avaliador.id;
        await this.obtemAvaliados(avaliadorId, this.avaliacao.competencia.id);
        this.$router.push({ name: 'Avaliados', params: { id: avaliadorId } });

        return;
      }
      this.$router.push({ name: 'Avaliacao' });
    },
  },

  created() {
    this.avaliacao = new Avaliacao(new Avaliado(), new Avaliador());
    this.obtemAvaliacaoENotas();
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao,
    EscondeDiv,
  },
};
</script>

<style scoped>
input[type='number'] {
  width: 3.2em;
}

.item {
  width: 50%;
}

.item p {
  margin: 5px 0 5px 0;
}

.item input {
  margin-bottom: 4px;
}

.anuencia {
  text-align: center;
  font-weight: bold;
  font-size: 1.2em;
  padding: 20px;
}

.anuencia-resultado {
  color: #00615c;
}
</style>



// WEBPACK FOOTER //
// detalha-avaliacao.vue?1b8b7162